import Cookies from 'js-cookie'
import {cartList} from '@/api/cart'
import { getToken, setToken, removeToken } from '@/utils/auth'
import {setCookie,getCookie} from '@/utils/support';

const app = {
  state: {
    // showList:false,
    user: '',
    status:'',
    name:'',
    nibd_company_id:'',
    token: getToken(),
    cartCount:null,
    activeColor:'',
  },
  mutations: {
    // SHOW_CHECKLIST: state => {
    //   state.showList = !state.showList
    // },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    // SET_USER: (state, user) => {
    //   state.user = user
    // },
    // SET_STATUS: (state, status) => {
    //   state.status = status
    // },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_COMPANYID: (state, nibd_company_id) => {
      state.nibd_company_id = nibd_company_id
    },
    GETCARTCOUNT: (state, cartCount) => {
      state.cartCount = cartCount
    },
    SET_ACTIVECOLOR: (state, activeColor) => {
      state.activeColor = activeColor
    },

  },
  actions: {
    // ShowCheckList: ({ commit }) => {
    //   commit('SHOW_CHECKLIST')
    // },
    getCartCount: ({ commit },cartCount) => {
      commit('GETCARTCOUNT',cartCount)
    },
    set_token: ({ commit },token) => {
      commit('SET_TOKEN',token)
    },
    set_name: ({ commit },name) => {
      commit('SET_NAME',name)
    },
    set_companyId: ({ commit },nibd_company_id) => {
      commit('SET_COMPANYID',nibd_company_id)
    },
    set_activeColor: ({ commit },activeColor) => {
      commit('SET_ACTIVECOLOR',activeColor)
    },
  }

}

export default app



// WEBPACK FOOTER //
// ./src/store/modules/app.js